import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import './App.css';
import Navbar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ThankYouPage from './pages/ThankYouPage';
import PlanningThankYouPage from './pages/PlanningThankYouPage';
import PartnerThankYouPage from './pages/PartnerThankYouPage';
import BrowseAllPage from './pages/BrowseAllPage';
import PartnerPage from './pages/PartnerPage';
import RequestBookingPage from './pages/RequestBookingPage';
import PlanningAssistancePage from './pages/PlanningAssistancePage';
import PartnerApplicationPage from './pages/PartnerApplicationPage';
import PersonalizedIdeasPage from './pages/PersonalizedIdeasPage';
import PackageRequestPage from './pages/PackageRequestPage';
import QuoteBuilderPage from './pages/QuoteBuilderPage';
import NotFoundPage from './pages/NotFoundPage';
import DocumentMeta from './seo/DocumentMeta';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      const pagePath = location.pathname + location.search;

      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: `${window.location.origin}${pagePath}`,
        page_path: pagePath,
      });
    }
  }, [location]);

  return null;
}

// Load the static archive when arriving through React navigation.
function BriefRedirect() {
  useEffect(() => {
    window.location.replace('/brief/index.html' + window.location.search + window.location.hash);
  }, []);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
     <DocumentMeta />
      <AnalyticsTracker />
     

      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/business/:id" element={<ProductPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/browse" element={<BrowseAllPage />} />
        <Route path="/partners" element={<PartnerPage />} />
        <Route
          path="/termsAndConditions"
          element={<TermsConditionsPage />}
        />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route
          path="/request-booking/:id"
          element={<RequestBookingPage />}
        />
        <Route
          path="/terms-conditions"
          element={<TermsConditionsPage />}
        />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route
          path="/planning-thank-you"
          element={<PlanningThankYouPage />}
        />
        <Route
          path="/partner-thank-you"
          element={<PartnerThankYouPage />}
        />
        <Route
          path="/planning-assistance"
          element={<PlanningAssistancePage />}
        />
        <Route
          path="/partner-application"
          element={<PartnerApplicationPage />}
        />
        <Route
          path="/personalized-ideas"
          element={<PersonalizedIdeasPage />}
        />
        <Route
          path="/package-request"
          element={<PackageRequestPage />}
        />
            <Route path="/quote-builder" element={<QuoteBuilderPage />} />
        <Route path="/brief" element={<BriefRedirect />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
